<div class="zas-row zas-headline-3">
    {{ division.Label }}
    <div *ngIf="division.ProductVersion" class="product-version">
        Versionsnummer: {{ division.ProductVersion }}
    </div>
</div>
<tracking-text
    [label]="productsByKey[division.ProductKey]?.riskName || 'Risiko'"
    name="risk"
    [full]="false"
    [data]="division.Risk"
    [validity]="validity"
></tracking-text>
<tracking-text
    label="Empfehlung"
    name="description"
    [data]="division.Recommendation.Description"
    [validity]="validity.recommendation"
    target="recommendation"
    [division]="division"
></tracking-text>
<tracking-text
    label="Begründung"
    name="reason"
    [show-additional]="false"
    [data]="division.Recommendation.Reason"
    [validity]="validity.recommendation"
    target="recommendationReason"
    [division]="division"
></tracking-text>

<!--zbd-simple-toggle [title]="'Empfehlungen zur Beendigung und Beitragsfreistellung von Versicherungsverträgen'" [isValidateable]="true" [isValid]="validity.recommendation.priorInsurances.valid"-->
<br />
<div class="zas-row zas-headline-4">
    Empfehlungen zur Beendigung und Beitragsfreistellung von
    Versicherungsverträgen
    <zbd-validity-indicator
        class="zbd-right"
        [validity]="validity.recommendation.priorInsurances"
    ></zbd-validity-indicator>
</div>
<!-- cancellations -->
<div class="zbd-slim-box">
    <div class="zas-row zbd-row-slim">
        <zbd-input
            type="radio"
            name="isCancellationRecommended"
            class="zas-main-col recommendation-option"
            label="Empfehlung der Beendigung eines Versicherungsvertrages"
            [value]="true"
            appearance="touch"
            [entity]="division.Recommendation"
            property="IsCancellationRecommended"
            [updateFn]="persistence.updateRecommendation"
        ></zbd-input>
    </div>
    <div class="zas-row zbd-row-slim">
        <zbd-input
            type="radio"
            name="isCancellationRecommended"
            class="zas-main-col recommendation-option"
            label="Kunde hat ohne Mitwirkung des Vermittlers die Versicherung gekündigt"
            [value]="false"
            appearance="touch"
            [entity]="division.Recommendation"
            property="IsCancellationRecommended"
            [updateFn]="persistence.updateRecommendation"
        ></zbd-input>
    </div>
    <div class="zas-row zbd-row-semi-slim">
        <zbd-input
            type="radio"
            name="isCancellationRecommended"
            class="zas-main-col recommendation-option"
            label="Keine Angaben"
            [value]="null"
            appearance="touch"
            [entity]="division.Recommendation"
            property="IsCancellationRecommended"
            [updateFn]="persistence.updateRecommendation"
        ></zbd-input>
    </div>
    <div *ngIf="division.Recommendation.IsCancellationRecommended != null">
        <div class="zas-row">
            <zbd-list
                itemName="Vertrag"
                class="zas-main-col"
                item-width="60%"
                [collection]="division.Recommendation.RecommendedCancellations"
                [template]="cancellation"
                [addFn]="addCancellation(division)"
                [deleteFn]="persistence.deleteCancellation"
                [validity]="validity.recommendation.cancellations"
            ></zbd-list>
        </div>
        <tracking-text
            label="Vor- und Nachteile für den Kunden"
            name="cancellationImpacts"
            [show-additional]="false"
            [data]="division.Recommendation.CancellationImpacts"
            [validity]="validity.recommendation"
            target="cancellationImpacts"
            [division]="division"
            class="zas-main-col"
        ></tracking-text>
    </div>
</div>

<!-- exemptions -->
<div class="zbd-slim-box">
    <div class="zas-row zbd-row-slim">
        <zbd-input
            type="radio"
            name="isExemptionRecommended"
            class="zas-main-col recommendation-option"
            label="Empfehlung der Beitragsfreistellung eines Versicherungsvertrages"
            [value]="true"
            appearance="touch"
            [entity]="division.Recommendation"
            property="IsExemptionRecommended"
            [updateFn]="persistence.updateRecommendation"
        ></zbd-input>
    </div>
    <div class="zas-row zbd-row-slim">
        <zbd-input
            type="radio"
            name="isExemptionRecommended"
            class="zas-main-col recommendation-option"
            label="Kunde hat ohne Mitwirkung des Vermittlers die Versicherung freigestellt"
            [value]="false"
            appearance="touch"
            [entity]="division.Recommendation"
            property="IsExemptionRecommended"
            [updateFn]="persistence.updateRecommendation"
        ></zbd-input>
    </div>
    <div class="zas-row zbd-row-semi-slim">
        <zbd-input
            type="radio"
            name="isExemptionRecommended"
            class="zas-main-col recommendation-option"
            label="Keine Angaben"
            [value]="null"
            appearance="touch"
            [entity]="division.Recommendation"
            property="IsExemptionRecommended"
            [updateFn]="persistence.updateRecommendation"
        ></zbd-input>
    </div>
    <div *ngIf="division.Recommendation.IsExemptionRecommended != null">
        <div class="zas-row">
            <zbd-list
                itemName="Vertrag"
                class="zas-main-col"
                item-width="60%"
                [collection]="division.Recommendation.RecommendedExemptions"
                [template]="exemption"
                [addFn]="addExemption(division)"
                [deleteFn]="persistence.deleteExemption"
                [validity]="validity.recommendation.exemptions"
            ></zbd-list>
        </div>
        <tracking-text
            label="Vor- und Nachteile für den Kunden"
            name="exemptionImpacts"
            [show-additional]="false"
            [data]="division.Recommendation.ExemptionImpacts"
            [validity]="validity.recommendation"
            target="exemptionImpacts"
            [division]="division"
            class="zas-main-col"
        ></tracking-text>
    </div>
</div>

<ng-template #cancellation let-item let-validity="validity">
    <div style="display: inline">
        <zbd-input
            type="text"
            [name]="item.Id"
            class="zas-inner-col-left"
            label="Gesellschaft"
            inlineLabel="true"
            [entity]="item"
            property="CancellationCompany"
            [updateFn]="persistence.updateCancellation"
            [securityFilter]="'light'"
        ></zbd-input>
        <zbd-input
            type="text"
            [name]="item.Id"
            class="zas-inner-col-right"
            label="VSNR"
            inlineLabel="true"
            [entity]="item"
            property="CancellationInsuranceNumber"
            [updateFn]="persistence.updateCancellation"
        ></zbd-input>
    </div>
</ng-template>

<ng-template #exemption let-item let-validity="validity">
    <div style="display: inline">
        <zbd-input
            type="text"
            [name]="item.Id"
            class="zas-inner-col-left"
            label="Gesellschaft"
            inlineLabel="true"
            [entity]="item"
            property="ExemptionCompany"
            [updateFn]="persistence.updateExemption"
            [validity]="validity"
            [securityFilter]="'light'"
        ></zbd-input>
        <zbd-input
            type="text"
            [name]="item.Id"
            class="zas-inner-col-right"
            label="VSNR"
            inlineLabel="true"
            [entity]="item"
            property="ExemptionInsuranceNumber"
            [updateFn]="persistence.updateExemption"
            [validity]="validity"
        ></zbd-input>
    </div>
</ng-template>
